import DashboardIncidentsMainAll from './DashboardIncidentsMainAll';

export default DashboardIncidentsMainAll;
